import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgHamburgerMenu = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={54} height={36} fill="none" viewBox="0 0 54 36" {...props}><Path fill="currentColor" d="M0 36v-6h54v6H0Zm0-15v-6h54v6H0ZM0 6V0h54v6H0Z" /></Svg>;
const Memo = memo(SvgHamburgerMenu);
export default Memo;